<app-main-table [tableConfig]="tableConfig" (sendInfoToComponent)="clickColumn($event)"></app-main-table>
